import React, { useState, useEffect } from 'react';
import { toast } from '../../toast/CustomToast'
import api from '../../../utils/api';

const EventsModal = ({
    isOpen,
    onClose,
    integration
}) => {
    const [loading, setLoading] = useState(false);
    const [events, setEvents] = useState([]);

    useEffect(() => {
        if (isOpen && integration) {
            loadEvents();
        }
    }, [isOpen, integration]);

    const loadEvents = async () => {
        setLoading(true);
        try {
            const response = await api.get(`/integrations/${integration.id}/events`);
            setEvents(response.data || []);
        } catch (error) {
            console.error('Erro ao carregar eventos:', error);
            toast.error('Erro ao carregar eventos');
        } finally {
            setLoading(false);
        }
    };

    const copyEventType = (eventType) => {
        navigator.clipboard.writeText(eventType).then(() => {
            toast.success('Tipo do evento copiado!');
        }).catch(() => {
            toast.error('Erro ao copiar tipo do evento');
        });
    };

    if (!isOpen || !integration) return null;

    return (
        <>
            {/* Overlay */}
            <div className="fixed inset-0 bg-black/50 z-30" onClick={onClose}></div>

            {/* Modal */}
            <div className="fixed right-0 top-0 h-screen w-full max-w-md bg-white dark:bg-gray-800 shadow-lg z-40 flex flex-col">
                {/* Header - Fixed */}
                <div className="p-6 border-b border-gray-200 dark:border-gray-700 flex-shrink-0">
                    <div className="flex items-center justify-between mb-6">
                        <div>
                            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">Eventos</h2>
                            <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">{integration.name}</p>
                        </div>
                        <button
                            onClick={onClose}
                            className="p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition"
                        >
                            <span className="material-icons sm">close</span>
                        </button>
                    </div>
                </div>

                {/* Scrollable Events List */}
                <div className="flex-grow overflow-y-auto filters-scroll">
                    <div className="p-6">
                        {/* Loading State */}
                        {loading && (
                            <div className="flex justify-center py-8">
                                <span className="material-icons animate-spin">refresh</span>
                            </div>
                        )}

                        {/* Empty State */}
                        {!loading && events.length === 0 && (
                            <div className="text-center py-8">
                                <span className="material-icons text-gray-400 dark:text-gray-500 text-4xl mb-2">schedule</span>
                                <p className="text-gray-500 dark:text-gray-400 text-sm">Nenhum evento associado</p>
                            </div>
                        )}

                        {/* Events List */}
                        {!loading && events.length > 0 && (
                            <div className="space-y-3">
                                {events.map(event => (
                                    <div key={event.id} className="p-4 border border-gray-200 dark:border-gray-600 rounded-lg bg-gray-50 dark:bg-gray-700/30 hover:shadow-sm transition">
                                        <div className="flex items-start gap-2">
                                            <span className="material-icons text-blue-500 flex-shrink-0 mt-1">schedule</span>
                                            <div className="flex-1 min-w-0">
                                                <p className="text-sm font-semibold text-gray-900 dark:text-white line-clamp-2">{event.name}</p>
                                                <p className="text-xs text-gray-600 dark:text-gray-400 mt-1 font-mono truncate">{event.id}</p>
                                                <div className="flex items-center gap-1 mt-2">
                                                    <span className="inline-block bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 px-2 py-1 rounded text-xs font-mono truncate flex-1 min-w-0">
                                                        {event.type}
                                                    </span>
                                                    <button
                                                        onClick={() => copyEventType(event.type)}
                                                        className="flex-shrink-0 p-1.5 bg-white dark:bg-gray-600 hover:bg-gray-100 dark:hover:bg-gray-500 border border-gray-300 dark:border-gray-500 rounded transition"
                                                        title="Copiar tipo do evento"
                                                    >
                                                        <span className="material-icons text-gray-600 dark:text-gray-300" style={{fontSize: '16px'}}>content_copy</span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>

                {/* Footer - Counter */}
                <div className="p-6 border-t border-gray-200 dark:border-gray-700 flex-shrink-0 bg-gray-50 dark:bg-gray-700/30">
                    <p className="text-sm text-gray-700 dark:text-gray-300 text-center">
                        <span className="font-semibold">{events.length}</span> evento(s) associado(s)
                    </p>
                </div>
            </div>
        </>
    );
};

export default EventsModal;
